import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Storefront as StoreIcon,
  Receipt as ReceiptIcon,
  Email as EmailIcon,
} from '@mui/icons-material';
import InventoryManagement from './inventory/InventoryManagement';
import OrderManagement from './inventory/OrderManagement';
import EmailSettings from './inventory/EmailSettings';

const ShopCart: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'inventory' | 'orders' | 'email'>('inventory');

  const handleTabChange = (event: React.SyntheticEvent, newValue: 'inventory' | 'orders' | 'email') => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'inventory':
        return <InventoryManagement />;
      case 'orders':
        return <OrderManagement />;
      case 'email':
        return <EmailSettings />;
      default:
        return <InventoryManagement />;
    }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ 
        p: 2, 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0'
      }}>
        <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center' }}>
          <StoreIcon sx={{ mr: 2, color: 'primary.main' }} />
          Lagerhantering och Order
        </Typography>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab 
            label="Lagerhantering - Butiksmaterial" 
            value="inventory"
            icon={<StoreIcon />}
          />
          <Tab 
            label="Ordrar" 
            value="orders"
            icon={<ReceiptIcon />}
          />
          <Tab 
            label="E-postinställningar" 
            value="email"
            icon={<EmailIcon />}
          />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {renderTabContent()}
      </Box>
    </Box>
  );
};

export default ShopCart; 